import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Autocomplete, TextField } from "@mui/material";
import { useState } from "react";

import { GeoRehandleDTO } from "../../../DTOs/Geology/GeoRehandleDTO";
import { GeoRehandleTruckingTruckDTO } from "../../../DTOs/Geology/GeoRehandleTruckingTruckDTO";

type PlantModelCellProps = {
  entry: GeoRehandleDTO
  bucketTypeOptions: GeoRehandleTruckingTruckDTO[]
  bucketTypeOptionsLoading: boolean
  handleUpdateRow: (row: GeoRehandleDTO) => Promise<boolean | undefined>
  isShiftLocked: boolean
}

const PlantModelCell: React.FC<PlantModelCellProps> = ({
  entry,
  bucketTypeOptions,
  bucketTypeOptionsLoading,
  handleUpdateRow,
  isShiftLocked
}) => {
  const [isLoading, setLoading] = useState(false);

  return (
    <Autocomplete
      disabled={isShiftLocked}
      classes={{ root: 'w-full' }}
      size="small"
      loading={bucketTypeOptionsLoading || isLoading}
      options={bucketTypeOptions}
      getOptionLabel={(option) => option.bucketType}
      value={bucketTypeOptions.find(x => x.bucketTypeId === entry.bucketTypeId) ?? null}
      isOptionEqualToValue={(option, value) => option.bucketTypeId === value.bucketTypeId}
      onChange={async (_event, newValue) => {
        if (newValue) {
          setLoading(true);
          await handleUpdateRow(
            { ...entry, bucketTypeId: newValue.bucketTypeId }
          );
          setLoading(false);
        }
      }}
      renderInput={(params) => <TextField
        {...params}
        label="Plant Model"
        slotProps={{
          ...params.slotProps,
          input: {
            ...params.slotProps.input,
            endAdornment: (
              <>
                {isLoading && <FontAwesomeIcon icon={faSpinner} spin />}
                {params.slotProps.input.endAdornment}
              </>
            )
          }
        }}
      />}
    />
  );
};

export default PlantModelCell;